import { tinaField, useTina } from "tinacms/dist/react";
import content from "../../../content/pages/about-us.json";
import { PageDocument } from "../../../tina/__generated__/types";
import { PageSeo } from "../../navigation/PageSeo";
import "./AboutUs.css";

const initialData = { page: content };
const variables = { relativePath: "about-us.json" };

export const AboutUs = () => {
  const { data } = useTina({ query: PageDocument, variables, data: initialData });
  const { hero, story, contact } = data.page;
  const phoneHref = contact.phoneNumber.replace(/[^\d+]/g, "");

  return (
    <main className="about-us-page">
      <PageSeo pathname="/about-us" seo={data.page.seo} />
      <section className="about-us-hero page-hero-dots">
        <div className="about-us-shell">
          <p className="about-us-eyebrow" data-tina-field={tinaField(hero, "eyebrow")}>
            {hero.eyebrow}
          </p>
          <h1 data-tina-field={tinaField(hero, "title")}>{hero.title}</h1>
          <p className="about-us-intro" data-tina-field={tinaField(hero, "intro")}>
            {hero.intro}
          </p>
        </div>
      </section>

      <section className="about-us-story about-us-shell" aria-labelledby="about-us-story-title">
        <div>
          <p className="about-us-eyebrow" data-tina-field={tinaField(story, "eyebrow")}>
            {story.eyebrow}
          </p>
          <h2 id="about-us-story-title" data-tina-field={tinaField(story, "title")}>
            {story.title}
          </h2>
        </div>
        <div className="about-us-story-copy">
          {(story.paragraphs ?? []).map((paragraph, index) => (
            <p key={index} data-tina-field={tinaField(story, "paragraphs", index)}>
              {paragraph}
            </p>
          ))}
        </div>
      </section>

      <section className="about-us-contact" aria-labelledby="about-us-contact-title">
        <div className="about-us-contact-inner about-us-shell">
          <div className="about-us-contact-copy">
            <p className="about-us-eyebrow">Get in touch</p>
            <h2 id="about-us-contact-title" data-tina-field={tinaField(contact, "title")}>
              {contact.title}
            </h2>
            <a className="about-us-phone" href={`tel:${phoneHref}`} data-tina-field={tinaField(contact, "phoneLabel")}>
              {contact.phoneLabel}
            </a>
            <a
              className="about-us-maps-link"
              href={contact.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-tina-field={tinaField(contact, "mapsLabel")}
            >
              {contact.mapsLabel}
              <span aria-hidden="true">&#8594;</span>
            </a>
          </div>
          <div className="about-us-map">
            <iframe
              src={contact.mapEmbedUrl}
              title="Google Maps location for Harmony of Soul"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutUs;
